import { PAYMENT_OPTIONS_LOGOS } from 'src/data/services/payment-logos';

const NAPOLI_CONFIG = {
    logo: { url: '/images/white-label/napolitickets.svg', title: 'Napoli Tickets' },
    websiteUrl: 'https://www.napolitickets.com',
    styling: {
        fontFamily: 'Oswald',
        fontUrl: 'https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap',
        cssVariables: {
            '--tco-custom-white-label-font': 'Oswald',
            '--tco-default-text-decoration': 'uppercase',
        },
    },
    cookiebotId: 'cc202b7a-a008-425b-b708-eccf90e5c23a',
    sessionEndImage: {
        url: 'https://ik.imagekit.io/p1/napoli-fans-2-scaled.jpg?updatedAt=1733399935980',
        alt: 'Napoli Fans',
    },
    paymentLogosOrder: [
        PAYMENT_OPTIONS_LOGOS.VISA,
        PAYMENT_OPTIONS_LOGOS.MASTERCARD,
        PAYMENT_OPTIONS_LOGOS.AMEX,
        PAYMENT_OPTIONS_LOGOS.PAYPAL,
        PAYMENT_OPTIONS_LOGOS.APPLE_PAY,
        PAYMENT_OPTIONS_LOGOS.TRUSTLY,
    ],
};

export const getWhiteLabelConfig = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('napolitickets')) {
        return NAPOLI_CONFIG;
    }

    return null;
};
